/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react';

import { DateTime } from 'luxon';
import { ImageBackground, ScrollView, View } from 'react-native';
import {
  Button,
  Card, Colors, DataTable,
} from 'react-native-paper';
import { useDispatch, useSelector } from 'react-redux';

import leths_back from '../../../assets/images/leths_back.png';
import { Header } from '../../../components/common';
import { AppButton, AppText } from '../../../components/form';
import { Logout, pixelDimensions } from '../../../config/utils';
import { getClasses, getDates } from '../../../redux/actions/trainerActions';
import { API } from '../../../service/api';
import styles from './styles';

export default function ClassData({ navigation }) {
  const { trainerData, classesData } = useSelector((state) => state.trainer);
  const [dates, setDates] = useState([]);
  const [presencial, setPresencial] = useState([]);
  const [online, setOnline] = useState([]);
  const [month, setMonth] = useState(0);
  const [thisMonth, setThisMonth] = useState(DateTime.now().toFormat('LL'));

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getClasses(trainerData.id_profissional, month !== 0));
    setThisMonth(month !== 0 ? DateTime.now().plus({ months: 1 }).toFormat('LL') : DateTime.now().toFormat('LL'));
    searchPersonalClasses().then((res) => setDates(res.sort(compare)));
  }, [month, thisMonth]);
  useEffect(() => {
    setOnline([]);
    setPresencial([]);
    const tempOnline = [];
    const tempPresencial = [];

    classesData.map((data) => {
      if (data.cd_tipo === 'ONLINE') {
        tempOnline.push(data);
      }
      if (data.cd_tipo === 'PRESENCIAL') {
        tempPresencial.push(data);
      }
      setOnline(tempOnline);
      setPresencial(tempPresencial);
    });
  }, [classesData]);

  function compare(a, b) {
    if (a.day < b.day) { return -1; }
    if (a.day > b.day) { return 1; }
    return 0;
  }
  function compareDate(a, b) {
    if (a.data < b.data) { return -1; }
    if (a.data > b.data) { return 1; }
    return 0;
  }

  const searchPersonalClasses = async () => {
    const aulas = await API.post('/search/usuario_personal', {
      where: `id_profissional = '${trainerData.id_profissional}' AND confirmado = '1'`,
    });

    const searchClasses = await Promise.all(aulas.data.data.map((_class) => {
      const getAll = API.post('/search/usuario', {
        where: `id_usuario = '${_class.id_usuario}'`,
      }).then((user) => {
        const tempDays = [];
        const {
          domingo, segunda, terca, quarta, quinta, sexta, sabado, horario, link: link_aula,
        } = _class;
        if (domingo) tempDays.push(0);
        if (segunda) tempDays.push(1);
        if (terca) tempDays.push(2);
        if (quarta) tempDays.push(3);
        if (quinta) tempDays.push(4);
        if (sexta) tempDays.push(5);
        if (sabado) tempDays.push(6);
        const datesa = getDates(tempDays, thisMonth);
        // eslint-disable-next-line array-callback-return
        const classes = datesa.map((date) => ({

          date: date.date,
          day: new Date(date.fullDate).getDate(),
          horario,
          link: link_aula,
          nome: user.data.data[0].nome,
          id_usuario: user.data.data[0].id_usuario,
        }));

        return classes;
      });

      return getAll;
    })).then((res) => res);
    const xClasses = [];
    searchClasses.map((test) => test.map((res) => xClasses.push(res)));
    return xClasses;
  };

  const listOnline = [];
  const listPresencial = [];
  const listTrainer = [];
  online.map((person) => {
    const personFind = listOnline.findIndex((id_e) => id_e.id_empresa === person.id_empresa);
    if (personFind === -1) {
      listOnline.push({
        empresa: person.nome_empresa,
        id_empresa: person.id_empresa,
      });
    }
  });

  presencial.map((person) => {
    const personFind = listPresencial.findIndex((id_e) => id_e.id_empresa === person.id_empresa);
    if (personFind === -1) {
      listPresencial.push({
        empresa: person.nome_empresa,
        id_empresa: person.id_empresa,
      });
    }
  });

  dates.map((person) => {
    const personFind = listTrainer.findIndex((id_u) => id_u.id_usuario === person.id_usuario);
    if (personFind === -1) {
      listTrainer.push({
        user: person.nome,
        id_usuario: person.id_usuario,
      });
    }
  });

  return (
    <ImageBackground source={leths_back} style={{ flex: 1 }}>
      <Header
        profilePic={trainerData.foto}
        canAlterPic="Alter Pic"
        navigation={navigation}
        userName={trainerData.nome}
      />
      <View style={styles.container}>
        <AppButton
          size="bold"
          label="MÊS ATUAL"
          rippleColor={Colors.white}
          style={styles.buttonBack}
          labelStyle={styles.textBack}
          onPress={() => setMonth(0)}
        />
        <AppButton
          size="bold"
          label="PROXIMO MÊS"
          rippleColor={Colors.white}
          style={styles.buttonBack}
          labelStyle={styles.textBack}
          onPress={() => setMonth(1)}
        />
      </View>
      <ScrollView style={styles.baseScroll}>
        <Card style={styles.cardAppointments}>
          <AppText size="bold" style={styles.textTitleCard}>Aulas Laborais Online</AppText>
          {online.length === 0 ? (<AppText style={{ alignSelf: 'center', marginTop: pixelDimensions(2) }}>Sem Aulas Agendadas.</AppText>) : (
            <DataTable>
              <DataTable.Header>
                <DataTable.Title>Empresa</DataTable.Title>
                <DataTable.Title numeric>#</DataTable.Title>
              </DataTable.Header>

              {listOnline.map((company) => {
                const tenant = online.filter((person) => person.id_empresa === company.id_empresa).sort(compareDate);

                return (
                  <DataTable.Row key={company.id_empresa}>
                    <DataTable.Cell>{company.empresa}</DataTable.Cell>
                    <DataTable.Cell numeric>
                      <Button
                        onPress={() => navigation.navigate('Class Tenant', { name: company.empresa, type: 'EMPRESA', classes: [...tenant] })}
                      >
                        Ver Agenda

                      </Button>
                    </DataTable.Cell>
                  </DataTable.Row>

                );
              })}
            </DataTable>
          )}
        </Card>
        <Card style={styles.cardAppointments}>
          <AppText size="bold" style={styles.textTitleCard}>Aulas Laborais Presenciais</AppText>
          {presencial.length === 0 ? (<AppText style={{ alignSelf: 'center', marginTop: pixelDimensions(2) }}>Sem Aulas Agendadas.</AppText>) : (

            <DataTable>
              <DataTable.Header>
                <DataTable.Title>Empresa</DataTable.Title>
                <DataTable.Title numeric>#</DataTable.Title>
              </DataTable.Header>

              {listPresencial.map((company) => {
                const tenant = presencial.filter((person) => person.id_empresa === company.id_empresa).sort(compareDate);
                return (
                  <DataTable.Row key={company.id_empresa}>
                    <DataTable.Cell>{company.empresa}</DataTable.Cell>
                    <DataTable.Cell numeric>
                      <Button
                        onPress={() => navigation.navigate('Class Tenant', { name: company.empresa, type: 'EMPRESA', classes: [...tenant] })}
                      >
                        Ver Agenda

                      </Button>
                    </DataTable.Cell>
                  </DataTable.Row>

                );
              })}
            </DataTable>
          )}
        </Card>
        <Card style={styles.cardAppointments}>
          <AppText size="bold" style={styles.textTitleCard}>{'Aulas Personal Trainer '}</AppText>

          {dates.length === 0 ? (<AppText style={{ alignSelf: 'center', marginTop: pixelDimensions(2) }}>Sem Aulas Agendadas.</AppText>) : (
            <DataTable>
              <DataTable.Header>
                <DataTable.Title>Aluno</DataTable.Title>
                <DataTable.Title numeric>#</DataTable.Title>
              </DataTable.Header>

              {listTrainer.map((user) => {
                const tenant = dates.filter((person) => person.id_usuario === user.id_usuario);

                return (
                  <DataTable.Row key={user.id_usuario}>
                    <DataTable.Cell>{user.user}</DataTable.Cell>
                    <DataTable.Cell numeric>
                      <Button
                        onPress={() => navigation.navigate('Class Tenant', { name: user.user, type: 'ALUNO', classes: [...tenant.sort(compare)] })}
                      >
                        Ver Agenda

                      </Button>
                    </DataTable.Cell>
                  </DataTable.Row>

                );
              })}
            </DataTable>
          )}
        </Card>

      </ScrollView>
      <AppButton
        size="bold"
        label="SAIR"
        rippleColor={Colors.white}
        style={styles.buttonBack}
        labelStyle={styles.textBack}
        onPress={() => Logout(navigation)}
      />

    </ImageBackground>
  );
}
